import { AttachmentFile } from "@rightship-tech/common-ui/models/attachments.models";

export interface RequestedInspectorCountryResponse {
    inspectorCountries: InspectionCountry[];
}

export interface RequestedInspectorResponse {
    requestedInspectors: RequestedInspector[];
}

export interface SaveInspectionProposalRequest {
    inspectors?: SaveInspectorModel[];
    trainees?: SaveTraineeModel[];
    proposalStatus: number;
    estimatedCost?: number;
}

export interface CancelInspectionRequest {
    reasonOption: string;
    reason?: string;
    encryptedData?: string;
}

export interface WithdrawInspectionRequest {
    withdrawalOption: string;
    withdrawalReason?: string;
}

export interface RescheduleInspectionRequest {
    newInspectionDate: Date;
    countryId: number;
    newPortId: number;
    days?: number;
    hours?: number;
    estimatedArrivalDate?: string | Date;
    newAgentName: string;
    newAgentOfficeNumber: string;
    newAgentEmailAddress: string;
    newPortName: string;
}

export interface RescheduleInspectionResponse {
    portName: string;
    countryName: string;
    validationResult: any;
}

export interface SaveInspectorModel {
    inspectorId: number;
    countryId: number;
}

export interface SaveTraineeModel {
    countryId?: number;
    email: string;
    mobileNumber: string;
    name: string;
}

export interface SaveInspectionProposalResponse {
    vesselName: string;
    vesselImo: string;
    port: string;
    country: string;
    requestedInspectionDate: string;
    validationResult: any;
    rsInspectionId?: number;
}

export interface InspectionCountry {
    countryId: number;
    countryName: string;
}

export interface RequestedInspector {
    inspectorId: number;
    inspectorName: string;
    hasConductedLastInspection: boolean;
}

export interface InspectionProposalDetailsModel {
    vesselDetails: InspectionProposalVesselDetailsModel;
    portAndOperationalDetails: PortAndOperationalDetailsModel;
    agentDetails: AgentDetailsModel;
    countryInspectors: CountryInspectorModel[];
    hasSubmittedProposal: boolean;
    isFreelancerInspector: boolean;
    isHybridInspection: boolean;
    isCancelled?: boolean;
    notFound: boolean;
    validationResult?: any;
}

export interface RightShipInspectionDetailsModel {
    vesselDetails?: InspectionProposalVesselDetailsModel;
    companyDetails?: InspectionproposalCompanyDetailsModel;
    portAndOperationalDetails?: PortAndOperationalDetailsModel;
    agentDetails?: AgentDetailsModel;
    rightShipInspectionId: number;
    hasPriorConversation: boolean;
    emailIdentifier: string;
    emailIdentifierTypeName: string;
    subtaskId?: number;
    statusId?: number;
    assignmentStatusActive?: boolean;
    hasAssignedInspector?: boolean;
    hasAssignmentWithdrawn?: boolean;
    validationResult: any;
    hasInspectionOutcomeV2: boolean;
}

export interface GetInspectionProposalInspectionInfoResponse {
    vesselName: string;
    vesselImo: string;
    portName: string;
    country: string;
    requestedInspectionDate: string;
    hasSubmittedProposal: boolean;
    isAssignmentActive: boolean;
    rightShipInspectionId: number;
    statusId: number;
}

export interface CountryInspectorModel {
    countryId: number;
    countryName: string;
    requestedInspectors: InspectorModel[];
}

export interface InspectionProposalVesselDetailsModel {
    
    vesselId?: number;
    vesselName: string;
    vesselImo: string;
    dateOfBuild?: string;
    vesselType?: string;
    dwt?: string;
    flag?: string;
}

export interface InspectionproposalCompanyDetailsModel {
    docCompanyOwCode: string;
    docCompanyName: string;
    docCompanyId: number;
}

export interface PortAndOperationalDetailsModel {
    requestedInspectionDate: string;
    port: string;
    portId?: number;
    country: string;
    countryId?: number;
    estimatedArrivalDate?: string;
    lengthOfTimeAtBerth?: string;
    cargoOperation?: string;
}

export interface AgentDetailsModel {
    agentName: string;
    agentOfficeNumber: string;
    agentEmailAddress: string;
}

export interface InspectorModel {
    inspectorId: number;
    countryId: number;
    inspectorName: string;
    hasConductedLatestInspection: boolean;
    showConductedLatestInspectionWarning: boolean;
    getSelectableInspectorsList?: (countryId: number) => InspectorModel[];
}

export interface CountryModel {
    id: number;
    name: string;
}

export interface PortModel {
    id: number;
    name: string;
}

export interface CurrencyModel {
    id: number;
    name: string;
    rate: number;
}

export interface TraineeModel {
    email: string;
    mobileNumber: string;
    name: string;
    contactCode: string;
    contactNumber: string;
}

export interface SubmmittedInspectionModel {
    vesselName: string;
    vesselImo: string;
    portName: string;
    country: string;
    requestedInspectionDate: string;
    previousInspectionDate?: string;
    inspectionNumber?: string;
    reason?: string;
    invoiceNumber?: string;
    agentName?: string;
    agentOfficeNumber?: string; 
    agentEmailAddress?: string;
}

export enum SubmitProposalStatusEnum {
    Submitted = 1,
    Declined = 2
}

export enum RightShipInspectionStatusEnum {
    Acceptable = 7,
    Unacceptable = 9,
    Cancelled = 10
}

export interface GetInspectionInvoiceSubmissionInfoResponse {
    vesselDetails: InspectionProposalVesselDetailsModel;
    portAndOperationalDetails: PortAndOperationalDetailsModel;
    agentDetails: AgentDetailsModel;
    hasSubmitted: boolean;
    estimatedCost: number;
    inspectionId: number;
    requestedInspectionDate: string;
    invoiceNumber: string;
    rightShipInspectionId: number;
}

export interface SubmitRightShipInspectionInvoiceRequest {
    invoiceCurrency: string;
    inspectionAmount: number;
    travelExpenseAmount: number;
    costOverrunReason: string;
    invoiceNumber: string;
    attachments: AttachmentFile[];
}

export interface SubmitRightShipInspectionInvoiceResponse {
    vesselName: string;
    vesselImo: string;
    portName: string;
    portCountry: string;
    inspectionDate: string;
}

export interface GetReviseProposalInspectionResponse {
    vesselDetails: InspectionProposalVesselDetailsModel;
    portAndOperationalDetails: PortAndOperationalDetailsModel;
    agentDetails: AgentDetailsModel;
    countryInspectors: CountryInspectorModel[];
    previousEstimatedCost: number;
    selectedInspectors: SaveInspectorModel[];
    selectedTrainee: SaveTraineeModel;
    isFreelancerInspector: boolean;
    isHybridInspection: boolean;
    isCancelled: boolean;
    notFound: boolean;
    remarks: string;
    rightShipInspectionStatusId: number;
    validationResult?: any;
}

export interface GetCurrentUserInfoResponse {
    inspectorEmail: string;
    inspectorEmailTypeName: string;
    rightShipInspectionId: number;
}

export interface PartialInspectionLayoutModel {
    vesselDetails: InspectionProposalVesselDetailsModel;
    portAndOperationalDetails: PortAndOperationalDetailsModel;
    rightShipInspectionId: string;
    agentDetails?: AgentDetailsModel;
}

export interface InspectionOutcomeReportModel {
    rightShipInspectionId: number;
    validUntilText: string;
    validUntil: Date;
    additionalCommentsForDurationOfValidity: string;
    statusName: string;
    statusId: number;
    customerId?: number;
    summary: string;
    formHasBeenSubmitted: boolean;
    closeoutType: string;
}